import classNames from "@calcom/ui/classNames";

const hideAppLogo = ["1", "true"].includes((process.env.NEXT_PUBLIC_HIDE_APP_LOGO || "").toLowerCase());
const hasCustomLogo = Boolean(process.env.NEXT_PUBLIC_APP_LOGO);
const hasCustomIconLogo = Boolean(process.env.NEXT_PUBLIC_APP_ICON_LOGO);

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  if (hideAppLogo) return null;

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img
            className={classNames("mx-auto w-9", !hasCustomIconLogo && "dark:invert")}
            alt="Logo"
            title="Logo"
            src={`${src}?type=icon`}
          />
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", !hasCustomLogo && "dark:invert")}
            alt="Logo"
            title="Logo"
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
